import * as React from 'react';

// PACKAGES
import { Link } from 'react-router-dom';

// COMPONENTS
import Button from '../../components/Button';
import CircleImage from '../../components/CircleImage';
import DisplayDate from '../../components/DisplayDate';
import OrganisationLogo from '../../components/OrganisationLogo';

// TYPES
import { OrganisationListOrganisation } from '../../api/models';

type CompaniesListItemVariant = 'active' | 'deactivated' | 'incomplete';

interface CompaniesListItemTypes {
	variant: CompaniesListItemVariant;
	item: OrganisationListOrganisation;
	onActivate?: (item: OrganisationListOrganisation) => void;
}

const CompaniesListItem: React.FC<CompaniesListItemTypes> = ({ variant, item, onActivate }) => {
	return (
		<div className="companies-grid-row">
			<div className="companies-grid-inner">
				<div className="companies-grid-icon">
					{variant === 'active' ? (
						<OrganisationLogo src={item.logo} size={40} />
					) : (
						<CircleImage src={item.logo} />
					)}
				</div>

				<div className="companies-grid-name">{item.name}</div>

				<div className="companies-grid-type">
					{variant === 'active' ? (
						item.organisationType
					) : (
						<span className="companies-grid-type-muted">{item.organisationType}</span>
					)}
				</div>

				{variant === 'deactivated' && (
					<div className="companies-grid-date">
						{item.statusDate && (
							<>
								<span className="companies-grid-date-label">Date Deactivated</span>
								<span className="companies-grid-date-value">
									<DisplayDate>{item.statusDate}</DisplayDate>
								</span>
							</>
						)}
					</div>
				)}

				<div className="companies-grid-action">
					<Link
						className={`companies-grid-action-link btn-text mtop-0 pdr-0 ${variant !== 'active' ? 'remove' : ''}`}
						to={`/companies/${item.id}`}
					>
						View
					</Link>

					{variant === 'deactivated' && onActivate && (
						<Button onClick={() => onActivate(item)} className="companies-grid-action-link btn-text mtop-0 pdr-0">
							Activate
						</Button>
					)}
				</div>
			</div>
		</div>
	);
};

export default CompaniesListItem;
